export interface TrainingLogNavItem {
  id: string;
  label: string;
  route: string;
  tab: string;
}

export const TRAINING_LOG_NAV_ITEMS: TrainingLogNavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    route: '/analytics/dashboard',
    tab: 'dashboard',
  },
  {
    id: 'training-log',
    label: 'Training Log',
    route: '/analytics/training-log',
    tab: 'training-log',
  },
  {
    id: 'raw-data',
    label: 'Raw Data',
    route: '/analytics/raw-data',
    tab: 'raw-data',
  },
  {
    id: 'data-info',
    label: 'Data Info',
    route: '/analytics/data-info',
    tab: 'data-info',
  },
];

export const getActiveTrainingLogTab = (pathname: string): string => {
  const match = TRAINING_LOG_NAV_ITEMS.find((item) => pathname.startsWith(item.route));
  return match?.tab ?? 'dashboard';
};

export const getActiveTrainingLogTabIndex = (pathname: string): number =>
  Math.max(
    0,
    TRAINING_LOG_NAV_ITEMS.findIndex((item) => pathname.startsWith(item.route))
  );

export const SPORT_LAYER_COLORS: Record<string, string> = {
  'XC Skiing': '#93C5FD',
  Run: '#C4B5FD',
  Bike: '#86EFAC',
  Gym: '#DDD6FE',
  Swim: '#7DD3FC',
  Other: '#D1D5DB',
};

export const FALLBACK_SPORT_COLORS = ['#60A5FA', '#A78BFA', '#34D399', '#FBBF24', '#F472B6', '#22D3EE'];

export const FOCUS_LAYER_COLORS: Record<string, string> = {
  Distance: '#93C5FD',
  Intensity: '#FCA5A5',
  Overdistance: '#A5B4FC',
  Recovery: '#86EFAC',
  Speed: '#FDE68A',
  Race: '#FCD34D',
  Pace: '#F9A8D4',
  Other: '#D1D5DB',
};

/** Canonical legend / panel ordering for known focus types */
export const FOCUS_ORDER: string[] = [
  'Distance',
  'Intensity',
  'Overdistance',
  'Recovery',
  'Speed',
  'Race',
  'Pace',
  'Other',
];

export const FALLBACK_FOCUS_COLORS = ['#FB923C', '#2DD4BF', '#E879F9', '#4ADE80', '#38BDF8'];
